module.exports = __webpack_public_path__ + "audio-36a96a0d211b.m4a";